






























import { Component, Vue, Watch } from 'vue-property-decorator';
import ApplicationModeService from '@/utils/application-mode-service';

@Component
export default class ApplicationModeSwitcher extends Vue {
  private ApplicationModeService = ApplicationModeService;

  private changeApplicationMode(mode: 'InvoicingMode' | 'PaycheckMode') {
    if (ApplicationModeService.currentMode === mode) return;

    if (this.$route.meta.applicationMode && this.$route.meta.applicationMode !== mode) {
      this.$router.push({ name: 'Dashboard' }).then(() => ApplicationModeService.setMode(mode));
    } else {
      ApplicationModeService.setMode(mode);
    }
  }

  @Watch('$route', { immediate: true })
  private changeApplicationModeByRoute() {
    const routeMode = this.$route.meta && this.$route.meta.applicationMode;
    if (routeMode) ApplicationModeService.setMode(routeMode);
  }
}
